import React from "react";
import { Link, useLocation } from "react-router-dom";
import { hasAccess, MODULES } from "../../utils/rbac";

const Monitoring = () => {
  const location = useLocation();

  const renderNavItem = (to, label, iconClass) => {
    const isActive = location.pathname === to;

    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}
        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <i className={`kt-menu__link-icon ${iconClass}`}></i>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <>
      {/* Monitoring Stock - cek permission monitoring_stock */}
      {hasAccess(MODULES.MONITORING_STOCK) &&
        renderNavItem(
          "/monitoring/stock",
          "Monitoring Stock",
          " flaticon2-soft-icons ",
        )}
      {hasAccess(MODULES.MONITORING_STOCK) &&
        renderNavItem(
          "/monitoring/stock/doc",
          "Monitoring Document",
          " flaticon2-soft-icons ",
        )}

      {/* Monitoring CCTV - cek permission monitoring_cctv */}
      {/* {hasAccess(MODULES.MONITORING_CCTV) && renderNavItem(
        "/monitoring/cctv",
        "Monitoring CCTV",
        "flaticon2-photo-camera"
      )} */}

      {/* Monitoring Anti Fraud - cek permission monitoring_anti_fraud */}
      {hasAccess(MODULES.MONITORING_ANTI_FRAUD) &&
        renderNavItem(
          "/monitoring/anti-fraud",
          "Monitoring Anti Fraud",
          "flaticon2-shield",
        )}

      {/* Monitoring User Activity - cek permission monitoring_user_activity */}
      {hasAccess(MODULES.MONITORING_USER_ACTIVITY) &&
        renderNavItem(
          "/monitoring/user-activity",
          "Monitoring User Activity",
          "flaticon2-user-outline-symbol",
        )}
    </>
  );
};

export default Monitoring;
